import React, { useEffect, useState } from 'react';
import { CloseIcon } from './shared/Icons';
import { cssUrl } from '../utils/cssVersion';
import ContractViewer from './ContractViewer';
const commonStyles = cssUrl('common.css');

// Back Arrow Icon Component
const BackArrowIcon = () => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2.5" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    style={{ width: '20px', height: '20px', flexShrink: 0 }}
  >
    <path d="M19 12H5" />
    <path d="m12 19-7-7 7-7" />
  </svg>
);

// Search Icon Component
const SearchIcon = () => (
  <svg className="mobile-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: '18px', height: '18px', flexShrink: 0 }}>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);






const HeaderComponent = ({
  title = 'Page Title',
  backRoute = '/profile',
  backLabel = 'Back',
  searchValue = '',
  onSearchChange,
  searchPlaceholder = 'Search...',
  showSearch = true,
  onBack,
  helpData= null,
}) => {

const [showHelp, setShowHelp] = useState(false);
useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = commonStyles;
    document.head.appendChild(link);
    return () => { 
      document.head.removeChild(link);
  };
  }, []);


  const handleBackClick = (e) => {
    if (onBack) {
      e.preventDefault();
      onBack();
    }
  };

  return (
    <div className="mobile-header">
      <div className="mobile-back-nav">
        <a 
          href={backRoute} 
          className="mobile-back-btn"
          onClick={onBack ? handleBackClick : undefined}
        >
          <BackArrowIcon />
          <span className="mobile-back-text">{backLabel}</span>
        </a>
      </div>
      <h1 className="mobile-title">{title}</h1>
      {showSearch && onSearchChange && (
        <div className="mobile-search-container">
          <SearchIcon />
          <input
            type="text"
            className="mobile-search-input"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      )}
      {helpData && helpData.length > 0 && (
  <button className="mobile-help-btn" onClick={() => setShowHelp(true)}>View Help ?</button>
)}
      {showHelp && helpData && (
  <div className="fr-modal-overlay" onClick={() => setShowHelp(false)}>
    <div className="fr-modal" onClick={(e) => e.stopPropagation()}>
      <div className="fr-modal-handle" />
      <div className="fr-modal-header">
        <h3 className="fr-modal-title">Help Guide</h3>
        <button className="fr-modal-close" onClick={() => setShowHelp(false)}>
          <CloseIcon />
        </button>
      </div>
      <div className="fr-modal-body">
        {helpData.map(({ chip, urlFilter }) => (
        <div key={chip} className="mt-6"> 
            <ContractViewer
              pdfUrl={urlFilter}
              height="400px"
              borderRadius="18px"
            />
          </div>
          
        ))}
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default HeaderComponent;